import { Context, createContext, PropsWithChildren, ReactElement } from "react";

const NO_UNIQUE_INPUT_ID_VALUE = { id: undefined };

export type UniqueInputIdContextData = {
	id: string | undefined;
};

export const UniqueInputIdContext: Context<UniqueInputIdContextData> = createContext<UniqueInputIdContextData>(
	NO_UNIQUE_INPUT_ID_VALUE
);

export const NoUniqueInputIdContext = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<UniqueInputIdContext.Provider value={NO_UNIQUE_INPUT_ID_VALUE}>
			{children}
		</UniqueInputIdContext.Provider>
	);
};
NoUniqueInputIdContext.displayName = "NoUniqueInputIdContext";
